export const CREATE_REPORT_CUSTOM_VIEW = "CREATE_REPORT_CUSTOM_VIEW";
export const CREATE_REPORT_CUSTOM_VIEW_SUCCESS =
  "CREATE_REPORT_CUSTOM_VIEW_SUCCESS";
export const CREATE_REPORT_CUSTOM_VIEW_FAILURE =
  "CREATE_REPORT_CUSTOM_VIEW_FAILURE";

export const FETCH_REPORT_CUSTOM_VIEW = "FETCH_REPORT_CUSTOM_VIEW";
export const FETCH_REPORT_CUSTOM_VIEW_SUCCESS =
  "FETCH_REPORT_CUSTOM_VIEW_SUCCESS";
export const FETCH_REPORT_CUSTOM_VIEW_FAILURE =
  "FETCH_REPORT_CUSTOM_VIEW_FAILURE";
export const RESET_REPORT_CUSTOM_VIEW = "RESET_REPORT_CUSTOM_VIEW";

export const SELECT_REPORT_CUSTOM_VIEW = "SELECT_REPORT_CUSTOM_VIEW";
export const SELECT_REPORT_CUSTOM_VIEW_SUCCESS =
  "SELECT_REPORT_CUSTOM_VIEW_SUCCESS";
export const SELECT_REPORT_CUSTOM_VIEW_FAILURE =
  "SELECT_REPORT_CUSTOM_VIEW_FAILURE";

export const DELETE_REPORT_CUSTOM_VIEW = "DELETE_REPORT_CUSTOM_VIEW";
export const DELETE_REPORT_CUSTOM_VIEW_SUCCESS =
  "DELETE_REPORT_CUSTOM_VIEW_SUCCESS";
export const DELETE_REPORT_CUSTOM_VIEW_FAILURE =
  "DELETE_REPORT_CUSTOM_VIEW_FAILURE";

export const FETCH_REPORT_CUSTOM_VIEW_BY_ID = "FETCH_REPORT_CUSTOM_VIEW_BY_ID";
export const FETCH_REPORT_CUSTOM_VIEW_BY_ID_SUCCESS = "FETCH_REPORT_CUSTOM_VIEW_BY_ID_SUCCESS";
export const FETCH_REPORT_CUSTOM_VIEW_BY_ID_FAILURE = "FETCH_REPORT_CUSTOM_VIEW_BY_ID_FAILURE";

export const EDIT_REPORT_CUSTOM_VIEW_BY_ID = "EDIT_REPORT_CUSTOM_VIEW_BY_ID";
export const EDIT_REPORT_CUSTOM_VIEW_BY_ID_SUCCESS = "EDIT_REPORT_CUSTOM_VIEW_BY_ID_SUCCESS";
export const EDIT_REPORT_CUSTOM_VIEW_BY_ID_FAILURE = "EDIT_REPORT_CUSTOM_VIEW_BY_ID_FAILURE";

export const UNSELECT_REPORT_CUSTOM_VIEW = "UNSELECT_REPORT_CUSTOM_VIEW";
export const UNSELECT_REPORT_CUSTOM_VIEW_SUCCESS = "UNSELECT_REPORT_CUSTOM_VIEW_SUCCESS";
export const UNSELECT_REPORT_CUSTOM_VIEW_FAILURE = "UNSELECT_REPORT_CUSTOM_VIEW_FAILURE";

// Candidate Static Report
export const FETCH_JOB_UNIVERSAL_REPORT_COUNT = "FETCH_JOB_UNIVERSAL_REPORT_COUNT";
export const FETCH_JOB_UNIVERSAL_REPORT_COUNT_SUCCESS = "FETCH_JOB_UNIVERSAL_REPORT_COUNT_SUCCESS";
export const FETCH_JOB_UNIVERSAL_REPORT_COUNT_FAILURE = "FETCH_JOB_UNIVERSAL_REPORT_COUNT_FAILURE";

export const FETCH_JOB_UNIVERSAL_REPORT_LISTING = "FETCH_JOB_UNIVERSAL_REPORT_LISTING";
export const FETCH_JOB_UNIVERSAL_REPORT_LISTING_SUCCESS = "FETCH_JOB_UNIVERSAL_REPORT_LISTING_SUCCESS";
export const FETCH_JOB_UNIVERSAL_REPORT_LISTING_FAILURE = "FETCH_JOB_UNIVERSAL_REPORT_LISTING_FAILURE";

// Universal Report Default Custom View
export const SET_DEFAULT_CUSTOM_VIEW = "SET_DEFAULT_CUSTOM_VIEW";
export const DELETE_DEFAULT_CUSTOM_VIEW = "DELETE_DEFAULT_CUSTOM_VIEW";

export const FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING = "FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING";
export const FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING_SUCCESS = "FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING_SUCCESS";
export const FETCH_JOB_UNIVERSAL_REPOR_JOBT_LISTING_FAILURE = "FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING_FAILURE";

// Job Report Default Custom View
export const SET_JOB_DEFAULT_CUSTOM_VIEW = "SET_JOB_DEFAULT_CUSTOM_VIEW";
export const DELETE_JOB_DEFAULT_CUSTOM_VIEW = "DELETE_JOB_DEFAULT_CUSTOM_VIEW";

// Job Reports Count
export const FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT = "FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT";
export const FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT_SUCCESS = "FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT_SUCCESS";
export const FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT_FAILURE = "FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT_FAILURE";
